(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('cargoTransactionController', cargoTransactionController)
        .controller('forChargingGuidesPayableCtrl', forChargingGuidesPayableCtrl)
        .controller('incomeRouteCtrl', incomeRouteCtrl);

    cargoTransactionController.$inject = ['$stateParams', 'datePickerService', '$translate', 'currencies',
        'regions', 'tabs', 'typeTransaction', 'branchOfficeService', 'linkService', 'dateService', 'transactionsService',
        'printService','userService','userSession', 'excelService'];

    forChargingGuidesPayableCtrl.$inject = ['datePickerService',
        'cities', 'tabs', 'linkService', 'dateService', 'transactionsService',
        'printService','userService','userSession', 'excelService'];

    incomeRouteCtrl.$inject = ['datePickerService',
        'cities', 'tabs', 'linkService', 'dateService', 'transactionsService',
        'printService','userService','userSession', 'excelService'];

    function cargoTransactionController($stateParams, datePickerService, $translate, currencies, regions, tabs,
                                          typeTransaction, branchOfficeService, linkService, dateService, transactionsService,
                                          printService,userService,userSession, excelService){
        var vm = this;
        vm.regionAll = [{name: 'Todas', initial: 'all'}];
        vm.branchOfficeAll = [{name: 'Todas', regionId: 0}];
        vm.userAll = [{name: 'Todas', userId: 0}];
        vm.currencies = currencies;
        vm.userSession = userSession.data;
        vm.regions = (regions.data._embedded) ? regions.data._embedded.regions : [];
        vm.typeTransaction = typeTransaction;
        if(vm.typeTransaction == 'region'){
            if(vm.userSession.positionType == "GENERAL_ADMIN"){
                vm.regions = vm.regionAll.concat(vm.regions);
            }else{
                vm.regions = getRegions(vm.regions,vm.userSession._embedded.branchOffices);
            }
        }else{
            if(vm.userSession.positionType != "GENERAL_ADMIN"){
                vm.regions = getRegions(vm.regions,vm.userSession._embedded.branchOffices);
            }
        }

        vm.branchOffices = [];
        vm.users = [];
        vm.tabs = tabs;

        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null && !vm.filterPassages.detail) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 30));
                    vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.filterPassages.toDate = args.closeDate;
                }
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };


        vm.filterPassages = {
            currency: null,
            region: null,
            branchOffice: null,
            user: null,
            detail: true,
            fromDate: null,
            toDate: null
        };

        vm.disabledUserBranch = false;
        vm.isBranch = false;
        vm.isReport = false;
        vm.isGeneralOrRegional = userService.isGeneralOrRegional(vm.userSession.positionType);
        vm.isDownload = false;
        vm.reportTransactionPassengerHtml = '';
        vm.toDate = null;
        vm.type = '';

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.onChangeDetail = function () {
            vm.datepickerFromDate.datepickerOptions.minDate = null;
            vm.datepickerFromDate.datepickerOptions.maxDate = new Date();
            vm.datepickerToDate.datepickerOptions.minDate = null;
            vm.datepickerToDate.datepickerOptions.maxDate = new Date();
            vm.filterPassages.toDate = null;
            vm.filterPassages.fromDate = null;
        }

        vm.onChangeRegion = function() {
            var region = vm.filterPassages.region;
            if (region !== null && region !== undefined) {
                vm.disabledUserBranch = false;
                if (vm.typeTransaction === 'branch') {
                    vm.branchOffices = [];
                    branchOfficeService.getBranchOfficesByRegion(linkService.getLinkId(region._links.self.href))
                        .then(function (response) {
                            var res = (response.data._embedded) ? response.data._embedded.branchOffices : [];
                            if(vm.userSession.positionType == "GENERAL_ADMIN" || vm.userSession.positionType == "REGIONAL_ADMIN"){
                                vm.branchOffices = vm.branchOfficeAll.concat(res);
                            }else{
                                vm.branchOffices = getBranchOffices(res,vm.userSession._embedded.branchOffices);
                            }
                        });
                } else {
                    vm.users = [];
                    branchOfficeService.getBranchOfficesByRegion(linkService.getLinkId(region._links.self.href))
                        .then(function (response) {
                            var res = (response.data._embedded) ? response.data._embedded.branchOffices : [];
                            vm.branchOffices = res;
                            if(vm.userSession.positionType == "COUNTER"){
                                vm.branchOffices = getBranchOffices(res,vm.userSession._embedded.branchOffices);
                            }
                        });
                }
            } else {
                vm.disabledUserBranch = false;
                vm.branchOffices = [];
                vm.users = [];
            }
        }

        vm.onChangeBranchOffice = function() {
            if (vm.typeTransaction == 'user') {
                var branchOffice = vm.filterPassages.branchOffice;
                if(branchOffice !== null && branchOffice !== undefined){
                    vm.users = [];
                    userService.getUsersByBranchOffice(linkService.getLinkId(branchOffice._links.self.href))
                        .then(function (response) {
                            var res = (response.data) ? response.data : [];
                            vm.users = res;
                            if(vm.userSession.positionType == "COUNTER"){
                                vm.users = getUsers(res,vm.userSession);
                            }
                        });
                }
            }
        }

        vm.cancelSalesBook = function (formGenerateSalesBook) {
            vm.filterSalesBook.taxpayer = null;
            vm.filterSalesBook.economicActivity = null;
            vm.filterSalesBook.management = null;
            formGenerateSalesBook.$setPristine();
        }

        vm.generateTransactionPassenger = function (isValid, formGenerateArching) {
            if(isValid){
                var newDate = new Date();
                var auxFromDate = vm.filterPassages.fromDate;
                vm.transactionCargo = {};
                vm.toDate = null;
                vm.type = '';
                vm.transactionCargo.fromDate = dateService.dateTimeString(auxFromDate, 1);
                vm.transactionCargo.toDate = (vm.filterPassages.detail) ? dateService.dateTimeString(auxFromDate, 2) : dateService.dateTimeString(vm.filterPassages.toDate, 2);
                vm.transactionCargo.currency = vm.filterPassages.currency.code;
                vm.transactionCargo.airRate = vm.filterPassages.rate;
                vm.transactionCargo.detail = vm.filterPassages.detail;

                if (vm.typeTransaction === 'region') {
                    vm.transactionCargo.region = (vm.filterPassages.region.name === 'Todas') ? 'all' : linkService.getLinkId(vm.filterPassages.region._links.self.href);
                    vm.transactionCargo.branch = false;
                    vm.transactionCargo.employee = '';
                    //vm.filterPassages.region = vm.filterPassages.region.initial;
                    vm.transactionCargo.branchOffice = '';
                } else if (vm.typeTransaction === 'branch') {
                    vm.transactionCargo.branch = true;
                    vm.transactionCargo.employee = '';
                    vm.transactionCargo.region = (vm.filterPassages.region.name === 'Todas') ? 'all' : linkService.getLinkId(vm.filterPassages.region._links.self.href);
                    vm.transactionCargo.branchOffice = (vm.filterPassages.branchOffice.name === 'Todas') ? 'all' : linkService.getLinkId(vm.filterPassages.branchOffice._links.self.href);
                } else {
                    vm.transactionCargo.branch = false;
                    vm.transactionCargo.region = (vm.filterPassages.region.name === 'Todas') ? 'all' : linkService.getLinkId(vm.filterPassages.region._links.self.href);
                    vm.transactionCargo.branchOffice = '';
                    vm.transactionCargo.region = '';
                    vm.transactionCargo.employee = (vm.filterPassages.user.name === 'Todas') ? '' : vm.filterPassages.user.login;
                }

                transactionsService.getTransactionsCargos(vm.transactionCargo).then(function (response) {
                    if(response !== undefined) {
                        vm.reportTransactionPassengerHtml = response.data;
                        vm.isReport = true;
                    } else {
                        vm.isReport = false;
                    }
                });
            }
        }

        vm.generateTrafficPdfHtml = function (target) {
            printService.printPdfHtml(target);
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, vm.filterPassages.detail ? 'report_detail' : 'report_total');
        }

        vm.cancelGenerateArching = function(formGenerateArching) {
            vm.filterArching.currency = null;
            vm.filterArching.toDate = 1;
            vm.filterArching.type = {"1": false, "2": false, "3": false};
            vm.filterArching.detail = true;
            vm.reportBalanceHtml = '';
            vm.toDate = null;
            vm.type = '';
            vm.isReport = false;
            formGenerateArching.$setPristine();
        };

        function getRegions(regions,branchOffices){
            var regionsAux = [];
            angular.forEach(regions, function (region) {
                angular.forEach(branchOffices, function (branchOffice) {
                    if(linkService.getLinkId(region._links.self.href)== branchOffice.regionId){
                        var bandThereIsRegionId = false;
                        angular.forEach(regionsAux, function (regionAux) {
                            if(linkService.getLinkId(region._links.self.href)== linkService.getLinkId(regionAux._links.self.href)){
                                bandThereIsRegionId = true;
                            }
                        })
                        if(!bandThereIsRegionId){
                            regionsAux.push(region);
                        }
                    }
                })
            })
            return regionsAux;
        }

        function getBranchOffices(branchOffices,sessionBranchOffices){
            var branchOfficesAux = [];
            angular.forEach(branchOffices, function (branchOffice) {
                angular.forEach(sessionBranchOffices, function (sessionBranchOffice) {
                    if(linkService.getLinkId(branchOffice._links.self.href)== linkService.getLinkId(sessionBranchOffice._links.self.href)){
                        branchOfficesAux.push(branchOffice);
                    }
                })
            })
            return branchOfficesAux;
        }

        function getUsers(users,sessionUser){
            var usersAux = [];
            angular.forEach(users, function (user) {
                if(linkService.getLinkId(user._links.self.href)== linkService.getLinkId(sessionUser._links.self.href)){
                    usersAux.push(user);
                }

            })
            return usersAux;
        }
    }

    function forChargingGuidesPayableCtrl(datePickerService, cities, tabs, linkService, dateService, transactionsService,
                                        printService,userService,userSession, excelService){
        var vm = this;
        vm.userSession = userSession.data;
        vm.cities = cities;
        if(vm.userSession.positionType == "GENERAL_ADMIN"){
            vm.cities = vm.cities;
        }else{
            vm.cities = getCities(vm.cities,vm.userSession._embedded.branchOffices);
        }

        vm.tabs = tabs;

        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null && !vm.filterPassages.detail) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 30));
                    vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.filterPassages.toDate = args.closeDate;
                }
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };


        vm.filterPassages = {
            currency: null,
            region: null,
            branchOffice: null,
            user: null,
            detail: true,
            fromDate: null,
            toDate: null
        };

        vm.isReport = false;
        vm.isGeneralOrRegional = userService.isGeneralOrRegional(vm.userSession.positionType);
        vm.isDownload = false;
        vm.reportTransactionPassengerHtml = '';
        vm.toDate = null;
        vm.type = '';

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.onChangeDetail = function () {
            vm.datepickerFromDate.datepickerOptions.minDate = null;
            vm.datepickerFromDate.datepickerOptions.maxDate = new Date();
            vm.datepickerToDate.datepickerOptions.minDate = null;
            vm.datepickerToDate.datepickerOptions.maxDate = new Date();
            vm.filterPassages.toDate = null;
            vm.filterPassages.fromDate = null;
        }

        vm.onChangeCity = function() {
            vm.isReport = false;
        }

        vm.generateTransactionPassenger = function (isValid, formGenerateArching) {
            if(isValid){
                var newDate = new Date();
                var auxFromDate = vm.filterPassages.fromDate;
                vm.transactionCargo = {};
                vm.toDate = null;
                vm.type = '';
                vm.transactionCargo.fromDate = dateService.dateTimeString(auxFromDate, 1);
                vm.transactionCargo.toDate = (vm.filterPassages.detail) ? dateService.dateTimeString(auxFromDate, 2) : dateService.dateTimeString(vm.filterPassages.toDate, 2);
                //vm.transactionCargo.currency = vm.filterPassages.currency.code;
                vm.transactionCargo.airRate = vm.filterPassages.rate;
                vm.transactionCargo.detail = vm.filterPassages.detail;

                var cityAux = linkService.getLinkId(vm.filterPassages.city._links.self.href);
                vm.transactionCargo.city = cityAux.substring(0,cityAux.indexOf('_'));

                transactionsService.getForChargingGuidesPayable(vm.transactionCargo).then(function (response) {
                    if(response !== undefined) {
                        vm.reportTransactionPassengerHtml = response.data;
                        vm.isReport = true;
                    } else {
                        vm.isReport = false;
                    }
                });
            }
        }

        vm.generateTrafficPdfHtml = function (target) {
            printService.printPdfHtml(target);
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, vm.filterPassages.detail ? 'report_detail' : 'report_total');
        }

        vm.cancelGenerateArching = function(formGenerateArching) {
            vm.filterArching.currency = null;
            vm.filterArching.toDate = 1;
            vm.filterArching.type = {"1": false, "2": false, "3": false};
            vm.filterArching.detail = true;
            vm.reportBalanceHtml = '';
            vm.toDate = null;
            vm.type = '';
            vm.isReport = false;
            formGenerateArching.$setPristine();
        };

        function getCities(cities,branchOffices){
            var citiesAux = [];
            angular.forEach(cities, function (city) {
                angular.forEach(branchOffices, function (branchOffice) {
                    var varCity = linkService.getLinkId(city._links.self.href);
                    if(varCity.substring(0,varCity.indexOf('_'))== branchOffice.cityId){
                        var bandThereIsCityId = false;
                        angular.forEach(citiesAux, function (cityAux) {
                            var varCityAux = linkService.getLinkId(cityAux._links.self.href);
                            if(varCity.substring(0,varCity.indexOf('_'))== varCityAux.substring(0,varCityAux.indexOf('_'))){
                                bandThereIsCityId = true;
                            }
                        })
                        if(!bandThereIsCityId){
                            citiesAux.push(city);
                        }
                    }
                })
            })
            return citiesAux;
        }
    }

    function incomeRouteCtrl(datePickerService, cities, tabs, linkService, dateService, transactionsService,
                                          printService,userService,userSession, excelService){
        var vm = this;
        vm.userSession = userSession.data;
        vm.disabledButton = false;
        vm.disabledCityDestiny = false;
        vm.cityAll = [{name: 'Todas', initial: 'all'}];
        vm.originCities = cities;
        vm.destinyCities = cities;
        vm.destinyCities = vm.cityAll.concat(vm.destinyCities);
        if(vm.userSession.positionType == "GENERAL_ADMIN"){
            vm.originCities = vm.cityAll.concat(vm.originCities);
        }else{
            vm.originCities = getCities(vm.originCities,vm.userSession._embedded.branchOffices);
        }

        if(vm.userSession.positionType == "COUNTER"){
            vm.disabledButton = true;
        }



        vm.tabs = tabs;

        vm.datePickerOpenStatus = {
            fromDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 30));
                }
            }
        };

        vm.filterPassages = {
            currency: null,
            region: null,
            branchOffice: null,
            user: null,
            fromDate: null,
        };

        vm.isReport = false;
        vm.isGeneralOrRegional = userService.isGeneralOrRegional(vm.userSession.positionType);
        vm.isDownload = false;
        vm.reportTransactionPassengerHtml = '';
        vm.type = '';

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
            vm.isReport = false;
        };

        vm.onChangeCity = function() {
            vm.isReport = false;
            var city = vm.filterPassages.originCity;
            if (city !== null && city !== undefined) {
                vm.disabledCityDestiny = false;
                if (city.initial === 'all') {
                    vm.disabledCityDestiny = true;
                    vm.destinyCities = vm.cityAll;
                    vm.filterPassages.destinyCity = vm.destinyCities[0];
                } else {
                    vm.disabledCityDestiny = false;
                    vm.destinyCities = cities;
                    vm.destinyCities = vm.cityAll.concat(vm.destinyCities);
                }
            } else {
                vm.disabledCityDestiny = false;
            }
        }

        vm.onChangeCityDestiny = function() {
            vm.isReport = false;
        }

        vm.generateTransactionPassenger = function (isValid, formGenerateArching) {
            if(isValid){
                var auxFromDate = vm.filterPassages.fromDate;
                vm.transactionCargo = {};
                vm.transactionCargo.fromDate = dateService.dateTimeString(auxFromDate, 1);
                vm.transactionCargo.toDate = dateService.dateTimeString(auxFromDate, 2);

                var originCityAux = (vm.filterPassages.originCity.initial === 'all') ? 'all' : linkService.getLinkId(vm.filterPassages.originCity._links.self.href);
                vm.transactionCargo.originCity = originCityAux==='all'? originCityAux: originCityAux.substring(0,originCityAux.indexOf('_'));

                var destinyCityAux = (vm.filterPassages.destinyCity.initial === 'all') ? 'all' : linkService.getLinkId(vm.filterPassages.destinyCity._links.self.href);
                vm.transactionCargo.destinyCity = destinyCityAux==='all'?destinyCityAux: destinyCityAux.substring(0,destinyCityAux.indexOf('_'));

                transactionsService.getIncomeRoute(vm.transactionCargo).then(function (response) {
                    if(response !== undefined) {
                        vm.reportTransactionPassengerHtml = response.data;
                        vm.isReport = true;
                    } else {
                        vm.isReport = false;
                    }
                });
            }
        }

        vm.generateTrafficPdfHtml = function (target) {
            printService.printPdfHtml(target);
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, 'report_income_route');
        }

        vm.cancelGenerateArching = function(formGenerateArching) {
            vm.filterArching.currency = null;
            vm.filterArching.type = {"1": false, "2": false, "3": false};
            vm.reportBalanceHtml = '';
            vm.type = '';
            vm.isReport = false;
            formGenerateArching.$setPristine();
        };

        function getCities(cities,branchOffices){
            var citiesAux = [];
            angular.forEach(cities, function (city) {
                angular.forEach(branchOffices, function (branchOffice) {
                    var varCity = linkService.getLinkId(city._links.self.href);
                    if(varCity.substring(0,varCity.indexOf('_'))== branchOffice.cityId){
                        var bandThereIsCityId = false;
                        angular.forEach(citiesAux, function (cityAux) {
                            var varCityAux = linkService.getLinkId(cityAux._links.self.href);
                            if(varCity.substring(0,varCity.indexOf('_'))== varCityAux.substring(0,varCityAux.indexOf('_'))){
                                bandThereIsCityId = true;
                            }
                        })
                        if(!bandThereIsCityId){
                            citiesAux.push(city);
                        }
                    }
                })
            })
            return citiesAux;
        }
    }
})();
